<template>
   <div>
        <div class="banner-box">
        </div>
        <div class="list-box">
            <div class="item-box" v-for="(item, index) in list" :key="index" @click="handleClickJump(item.link)">
                <div class="img-box">
                    <img :src="item.image" alt="" style="height: 100%; width: 100%; object-fit:fill ;" />

                </div>
                <div class="desc-box">
                    <div class="title">
                        {{ item.title }}
                    </div>
                    <!-- <div class="desc" style="color: #A8B1BE;text-align: right;">
                        {{ $moment(item.releaseTime).format("YYYY-MM-DD") }}
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: []
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
			this._get(this.API.caseList).then(res => {
				if(res.code == 200) {
					this.list = res.data.records
				}
			})
		},
        handleClickJump(link) {
			window.open(link)
		},
    },
}
</script>


<style lang="less" scoped>
.banner-box {
    height: calc(100vw / (1920 / 500) + 3rem) /* 500/50 */;
    width: 100%;
    background: url("../../../assets/images/case-banner.png") center no-repeat;
    background-size: cover ;
    background-position: center; 
}
.list-box {
    padding: .8rem /* 40/50 */ .8rem /* 40/50 */;
}
.item-box {
    margin-bottom: .52rem /* 26/50 */;
    // 阴影
    box-shadow: 0 0 .2rem /* 1/50 */ rgba(0, 0, 0, 0.1);
    border-radius: .48rem /* 24/50 */
}
.img-box {
    height: 6rem /* 300/50 */;
    width: 100%;
    img {
    border-radius: .48rem /* 24/50 */ .48rem /* 24/50 */ 0 0;

    }
}
.desc-box {
    font-size: .52rem /* 26/50 */;
    padding: .16rem /* 8/50 */ .4rem /* 20/50 */ .4rem /* 20/50 */ .4rem /* 20/50 */;
    .title {
        height: 1.28rem /* 64/50 */;
        overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
}

</style>